import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { Items } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectItems } from '../Selectors/Master/ItemSelectors';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { createJobRateEntry } from '../../Store/PHPSlice/JobRate';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';


const JobRateEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        itemId: '',
        total: '0',
        extra: '0',
        contractor: '0',
        userId: userdata?.userId
    });

    const [departData, setDepartData] = useState([]);
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    const departlist = useSelector(selectDaparement);
    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchDepartmentData());
    }, [dispatch]);

    useEffect(() => {
        if (departlist?.data?.length > 0) {
            const data3 = JSON.parse(JSON.stringify(departlist?.data));
            setDepartData(data3);
        }
    }, [departlist]);



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e, index) => {
        const { value } = e.target;

        // Update the specific department's value
        const updatedDepartData = departData.map((dept, idx) =>
            idx === index ? { ...dept, val: value } : dept
        );

        setDepartData(updatedDepartData);

        // Calculate the total and update formData
        let total = updatedDepartData.reduce(
            (sum, dept) => sum + parseFloat(dept.val || 0),
            0
        );
        total = (parseFloat(formData.extra) + total);
        setFormData((prev) => ({ ...prev, total: total.toFixed(2) }));
    };

    const handleExtraChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (name === 'extra' && value) {
            const sum = parseFloat(formData.total) + parseFloat(value);
            setFormData(prev => ({
                ...prev,
                total: sum.toFixed(2)
            }));
        }
    };
    const dropdownlistfirst = [

        {
            label: 'Item',
            id: 'itemId',
            options: itemList?.data || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    function postObj(formData, departData) {
        const data = {
            dt: formData.dt,
            itemId: formData.itemId,
            userId: formData.userId,
            extra: formData.extra,
            total: formData.total,
            departData: departData
        };
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const postdata = postObj(formData, departData);
        // console.log(postdata);
        dispatch(createJobRateEntry(postdata))
            .unwrap()
            .then((result) => {
                // Handle success
                if (result.msg === 'Already Exits') {
                    alert('Already Exits');
                    window.location.reload();
                } else {
                    console.log('POST request successful!', result);
                    alert("Job Rate Added");
                    window.location.reload();
                }

                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={Items} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Item Job Rate Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="itemId">Item :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="itemId"
                                                    id="itemId"
                                                    name="itemId"
                                                    value={formData.itemId}
                                                    onChange={(e) => handleDropdownChange(e, 'itemId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        itemList ? itemList.data.map((val, index) => (
                                                            <MenuItem key={index} value={val.ID}>{val.itemNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }


                                {departData?.length > 0 &&
                                    <table>
                                        <thead>
                                            {departData?.map((dept, index) => (<th key={index}>{dept.departNm}</th>))}
                                            <th>Extra</th>
                                            <th>Total</th>
                                        </thead>
                                        <tbody>
                                            {departData?.map((dept, index) => (
                                                <td key={index}>
                                                    <input
                                                        type='text'
                                                        placeholder='0'
                                                        value={dept.val || ""}
                                                        onChange={(e) => handleInputChange(e, index)}
                                                        style={{ width: '100px', fontSize: '17px' }}
                                                    />
                                                </td>))}
                                            <td>
                                                <input
                                                    type='text'
                                                    placeholder='0'
                                                    name='extra'
                                                    value={formData.extra || ""}
                                                    onChange={(e) => handleExtraChange(e)}
                                                    style={{ width: '100px', fontSize: '17px' }}
                                                />
                                            </td>
                                            <td style={{ fontSize: '17px' }}>
                                                {formData.total}
                                            </td>
                                        </tbody>
                                    </table>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default JobRateEntry;
